module.exports = __webpack_public_path__ + "media/src/assets/Images/RealEstateHomeMobile-39ba3aa070b0dc26385a3d26b9f84ae8.png";